import React from "react";
import { Modal, Descriptions } from "antd";
import dayjs from "dayjs";
import { COMMON_DICTS, getMetadataLabel } from "@ifa/utils";

interface BeneficiaryDetailModalProps {
  open: boolean;
  beneficiary: any;
  onClose: () => void;
}

export function BeneficiaryDetailModal({ open, beneficiary, onClose }: BeneficiaryDetailModalProps) {
  if (!beneficiary) return null;

  return (
    <Modal open={open} onCancel={onClose} footer={null} width={800} centered title={<div style={{ fontSize: 20, fontWeight: 600 }}>受益人詳情</div>}>
      <div style={{ maxHeight: "70vh", overflowY: "auto", padding: "16px 0" }}>
        {/* Basic Info Section */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, color: "#333" }}>基本資料</div>
          <Descriptions column={2} colon={false} layout="vertical">
            <Descriptions.Item label={<span style={{ color: "#999" }}>身份證明文件類型</span>}>
              <span style={{ color: "#333", fontWeight: 500 }}>{getMetadataLabel("ID_TYPE", beneficiary.basic?.idType, COMMON_DICTS.idType)}</span>
            </Descriptions.Item>
            <Descriptions.Item label={<span style={{ color: "#999" }}>身份證明文件號碼</span>}>
              <span style={{ color: "#333", fontWeight: 500 }}>{beneficiary.basic?.idNumber || "-"}</span>
            </Descriptions.Item>
            <Descriptions.Item label={<span style={{ color: "#999" }}>姓名(中文)</span>}>
              <span style={{ color: "#333", fontWeight: 500 }}>
                {beneficiary.basic?.chineseSurname || ""}
                {beneficiary.basic?.chineseGivenName || "" || "-"}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label={<span style={{ color: "#999" }}>姓名(英文)</span>}>
              <span style={{ color: "#333", fontWeight: 500 }}>
                {beneficiary.basic?.englishSurname || ""} {beneficiary.basic?.englishGivenName || "" || "-"}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label={<span style={{ color: "#999" }}>出生日期</span>}>
              <span style={{ color: "#333", fontWeight: 500 }}>{beneficiary.basic?.birthDate ? dayjs(beneficiary.basic.birthDate).format("YYYY-MM-DD") : "-"}</span>
            </Descriptions.Item>
            <Descriptions.Item label={<span style={{ color: "#999" }}>性別</span>}>
              <span style={{ color: "#333", fontWeight: 500 }}>{getMetadataLabel("GENDER", beneficiary.basic?.gender, COMMON_DICTS.gender)}</span>
            </Descriptions.Item>
          </Descriptions>
        </div>

        {/* Relationship & Percentage Section */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, color: "#333" }}>關係及受益資料</div>
          <Descriptions column={2} colon={false} layout="vertical">
            <Descriptions.Item label={<span style={{ color: "#999" }}>與受保人關係</span>}>
              <span style={{ color: "#333", fontWeight: 500 }}>{getMetadataLabel(null, beneficiary.relationship, COMMON_DICTS.relationship)}</span>
            </Descriptions.Item>
            <Descriptions.Item label={<span style={{ color: "#999" }}>受益比例</span>}>
              <span style={{ color: "#333", fontWeight: 500 }}>{beneficiary.percentage ?? 0}%</span>
            </Descriptions.Item>
          </Descriptions>
        </div>

        {/* Contact Info Section (if available) */}
        {(beneficiary.personal?.phone || beneficiary.personal?.email || beneficiary.personal?.address) && (
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, color: "#333" }}>聯絡資料</div>
            <Descriptions column={2} colon={false} layout="vertical">
              {beneficiary.personal?.phone && (
                <Descriptions.Item label={<span style={{ color: "#999" }}>手提電話</span>}>
                  <span style={{ color: "#333", fontWeight: 500 }}>{beneficiary.personal.phone}</span>
                </Descriptions.Item>
              )}
              {beneficiary.personal?.email && (
                <Descriptions.Item label={<span style={{ color: "#999" }}>電郵</span>}>
                  <span style={{ color: "#333", fontWeight: 500 }}>{beneficiary.personal.email}</span>
                </Descriptions.Item>
              )}
              {beneficiary.personal?.address && (
                <Descriptions.Item label={<span style={{ color: "#999" }}>地址</span>} span={2}>
                  <span style={{ color: "#333", fontWeight: 500 }}>{beneficiary.personal.address}</span>
                </Descriptions.Item>
              )}
            </Descriptions>
          </div>
        )}

        {/* Remarks Section */}
        <div>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, color: "#333" }}>備註/說明</div>
          <div
            style={{
              padding: 16,
              background: "#FAFAFA",
              borderRadius: 8,
              color: "#333",
              lineHeight: "1.6",
              minHeight: 60,
            }}
          >
            {beneficiary.other?.remark ?? beneficiary.remark ?? "-"}
          </div>
        </div>
      </div>
    </Modal>
  );
}
